import React from 'react';
import { TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const DateTimePickerWrapper = ({ field, value, onChange, error }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        label={field.label}
        value={value || null}
        onChange={(newValue) => onChange(field.name, newValue)}
        ampm={false}
        format="DD.MM.YYYY HH:mm"
        slotProps={{
          textField: {
            fullWidth: true,
            error: Boolean(error),
            helperText: error ? <span style={{ color: "red" }}>{error}</span> : "",
            sx: { marginBottom: "15px" },
          },
        }}
        minDateTime={field.minDateTime}
        maxDateTime={field.maxDateTime}
        renderInput={(params) => <TextField {...params} />}
      />
    </LocalizationProvider>
  );
};

export default DateTimePickerWrapper;
